<div class="main-wrap">
  <div class="calander-wrapper">
    <div class="ui-g">
      <div
        *ngFor="let data of ResultData"
        class="ui-g-6 ui-lg-6 ui-md-6 ui-sm-12"
      >
        <div class="calander-card">
          <div class="cal-content">
            <img class="calan-icon" src="assets/images/cal1.jpeg" alt="" />
            <p class="sub-heading">AAI Calendar</p>
            <p class="heading">{{ data?.year }}</p>
            <div
              class="click-here"
              (click)="openCalendar(global.basePathImage + data?.link)"
            >
              Click here to see report
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="ResultData.length === 0" class="nodata">No data found!</div>
  </div>
</div>
